export type PaymentConditionState = "not_paid" | "wait_shipped" | "met";

export const getPaymentConditionStatus = (
  paymentStatus: string | undefined,
  paymentDate: string | null | undefined,
  itemStatus: string | undefined
): { state: PaymentConditionState; days: number } => {
  if (paymentStatus !== "confirm" || !paymentDate) {
    return { state: "not_paid", days: 0 };
  }
  const diffDays = Math.floor(
    (Date.now() - new Date(paymentDate).getTime()) / (1000 * 60 * 60 * 24)
  );
  if (diffDays < 7) {
    return { state: "not_paid", days: diffDays };
  }
  if (itemStatus === "shipped") {
    return { state: "met", days: diffDays };
  }
  return { state: "wait_shipped", days: diffDays };
};

const ORDER_STATUS_LABELS: Record<string, string> = {
  wait_factory_approve: "รอรับคำสั่งซื้อ",
  factory_approve: "เตรียมจัดส่ง",
  wait_agent_confirm: "ระหว่างจัดส่ง",
  shipped: "เสร็จสิ้น",
};

export const getOrderStatusLabel = (status: string | undefined): string => {
  if (!status) return "-";
  return ORDER_STATUS_LABELS[status] ?? status;
};

/** item_status ที่ถือว่า "ยกเลิก" — backend ส่ง "cancel" มา แต่รองรับสะกดแบบอื่นไว้ด้วย */
const CANCELED_ITEM_STATUSES = ["cancel", "canceled", "cancelled"];

export const isCanceledItemStatus = (status: string | undefined | null): boolean =>
  !!status && CANCELED_ITEM_STATUSES.includes(status.toLowerCase());
